import { useSelector } from 'react-redux';
import * as TaxService from 'services/tax';

export const useTaxService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchTaxes = async (options = {}) => {
    const { error, payload } = await TaxService.read({ ...options, token });
    if (error) {
      return { taxes: [], size: 0 };
    }

    const {
      data: taxes,
      meta: { size }
    } = payload;
    return { taxes, size };
  };

  return {
    fetchTaxes
  };
};
